import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { createNotification } from '../../../Config/NotificationToast';
import { instance } from "../../auth/axiosInstance";
import { logOut } from '../../../utils/Helper';
import { DOWNLOAD_RECOMMENDATIONS_EXCEL, GET_RECOMMENDATIONS, GET_THERAPIST_LIST } from '../../constants';
import { download_recommendation_excel_API, get_recommendations_API, get_therapist_list_API } from '../../../Config/Api';

const getTherapistListApi = async (data) => {
    try {
        const response = await instance.get(`${get_therapist_list_API}?${data.date_filter ? `&filter_date=${data.date_filter}`: ''}`, {
            data,
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 400) {
            // createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}
function* getTherapistList(action) {
    try {
        const response = yield call(getTherapistListApi, action.data);
        if (response?.statusCode === 200) {
            yield put({ type: 'GET_THERAPIST_LIST_SUCCESS', payload: response.data });
        } else {
            if (response?.statusCode === 401) {
                logOut('error', response?.message);
            } else {
                createNotification('error', response?.message);
                yield put({ type: 'GET_THERAPIST_LIST_FALIURE', message: response?.message });
            }
            
        }
        
    } catch (e) {
        console.log(e);
        yield put({ type: 'GET_THERAPIST_LIST_FALIURE', message: e.message });
    }
}

const downloadRecommendationsExcelApi = async(data)=> {
    try {
        const response = await instance.get(`${download_recommendation_excel_API}?${data.searchText ? `&filter_text=${data.searchText}`: ''}${data.therapist_name ? `&filter_therapist=${data.therapist_name}`: ''}${data.date_filter ? `&filter_date=${data.date_filter}`: ''}${data.orderBy ? `&order_by=${data.orderBy}`: ''}${data.order ? `&order_by_type=${data.order}`: ''}`, {
            responseType: 'arraybuffer',
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response?.data.statusCode === 400) {
            createNotification('error', errors.response?.data.message);
            return
        } if (errors.response?.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
  }
  function* downloadRecommendationsExcel(action) {
    try {
        
        let data=action.data
        const response = yield call(downloadRecommendationsExcelApi, data);
        if (response instanceof ArrayBuffer) {
            action.data?.onSuccessCallback(response)
            yield put({ type: 'DOWNLOAD_RECOMMENDATIONS_EXCEL_SUCCESS' });
        }else{
            createNotification('Unable to download sheet.')
            yield put({ type: 'DOWNLOAD_RECOMMENDATIONS_EXCEL_FALIURE'});
        }
        
    } catch (e) {
        console.log(e);
        yield put({ type: 'DOWNLOAD_RECOMMENDATIONS_EXCEL_FALIURE', message: e.message });
    }
}


const getRecommendationsApi = async (data) => {
    try {
        const response = await instance.get(`${get_recommendations_API}?page=${data.pageNo}&limit=${data.pageSize || 10}${data.searchText ? `&filter_text=${data.searchText}`: ''}${data.therapist_name ? `&filter_therapist=${data.therapist_name}`: ''}${data.date_filter ? `&filter_date=${data.date_filter}`: ''}${data.orderBy ? `&order_by=${data.orderBy}`: ''}${data.order ? `&order_by_type=${data.order}`: ''}`);
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}
function* getRecommendations(action) {
    try {
        const response = yield call(getRecommendationsApi, action.data);
        if (response.statusCode === 200) {
            yield put({ type: 'GET_RECOMMENDATIONS_SUCCESS', payload: response.data });
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message);
            } else {
                createNotification('error', response.message);
                yield put({ type: 'GET_RECOMMENDATIONS_FALIURE', message: response.message });
            }
            
        }
        
    } catch (e) {
        console.log(e);
        yield put({ type: 'GET_RECOMMENDATIONS_FALIURE', message: e.message });
    }
}

function* RecommendationsSaga(){
    yield takeLatest(GET_THERAPIST_LIST, getTherapistList)
    yield takeLatest(DOWNLOAD_RECOMMENDATIONS_EXCEL, downloadRecommendationsExcel)
    yield takeLatest(GET_RECOMMENDATIONS, getRecommendations)
}

export default RecommendationsSaga;